module.exports = __webpack_public_path__ + "img/US_BonusDamagevsPriests_ua.a9f5726c.webp";